import CSR_Committee_Details from "../assets/csr_pdf/CSR_Committee_Constitution.pdf";
import CSR_Policy from "../assets/csr_pdf/CSR_Policy.pdf";
export const CsrData = {
  page: [    {
      title: "CSR Policy",
      sections: [
        {
          id: 1,
          title: "CSR Policy",
          url: CSR_Policy,
        }
      ],
    },
    {
      title: "CSR Committee Constitution",
      sections: [
        {
          id: 1,
          title: "CSR Committee Constitution",
          url: CSR_Committee_Details,
        },
      ],
    }
  ]
};